<template>
  <div class="achievement list-item">
    <div class="achievement-icon">
      emoji_events
    </div>
    <div class="text-block">
      {{ text }}
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "AchivementItem",
  props: {
    text: { type: String },
  }
}
</script>

<style scoped>
.achievement {
  background: linear-gradient(200deg,#e74a23,#e9671f,#ec841b,#efa118);
  display: block;
  height: 9vh;
  padding-top: 1vh;
  width: 30vh;
  margin: 0 0.5vh;
  border-radius: 1vw;
  color: white;
  border: 4px solid #e9671f;
  font-weight: bold;
  position: relative;
  box-shadow: 0.5vh 0.5vh 1vh rgba(0,0,0,0.3);
}
.achievement-icon {
  position: absolute;
  width: 30%;
  left: 0;
  text-align: center;
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 7vh;
  height: 9vh;
  line-height: 9vh;

  pointer-events: none;
  color: white;
}
.text-block {
  display: block;
  position: absolute;
  width: 70%;
  text-align: left;
  right: 0;
  font-size: 2.5vh;
}
</style>



// WEBPACK FOOTER //
// src/components/common/achievement/AchivementItem.vue